import { render, staticRenderFns } from "./PlayButton.vue?vue&type=template&id=736af647&scoped=true"
var script = {}
import style0 from "./PlayButton.vue?vue&type=style&index=0&id=736af647&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736af647",
  null
  
)

export default component.exports